define('lq/parameterCollection',[
    'underscore'
], function (_) {

    var getInternalKey = function (key) {
        // fallback to empty string for EPP
        return (key || '').toLowerCase();
    };

    var ParameterCollection = function (initialValues, parentCollection) {
        this.parameters = {};
        this.parentCollection = parentCollection;

        if (initialValues) {
            var self = this;
            _.each(_.keys(initialValues), function (key) {
                self.setValue(key, initialValues[key]);
            });
        }
    };
        
    ParameterCollection.prototype.getValue = function (key) {
        var entry = this.parameters[getInternalKey(key)];

        if (entry) {
            if (typeof entry.value === 'function')
                return entry.value();
            return entry.value;
        }

        if (this.parentCollection)
            return this.parentCollection.getValue(key);
        
        return undefined;
    };

    ParameterCollection.prototype.setValue = function (key, value) {
        if (!key) return;

        var internalKey = getInternalKey(key);

        if (this.parameters[internalKey])
            this.parameters[internalKey].value = value;
        else
            this.parameters[internalKey] = {
                key: key,
                value: value
            };

        this.informSubscribers(internalKey, value);
    };

    ParameterCollection.prototype.parameterExists = function (key) {
        var internalKey = getInternalKey(key);
        return this.parameters.hasOwnProperty(internalKey);
    };

    ParameterCollection.prototype.clear = function (key) {
        this.setValue(key, null);
    };

    ParameterCollection.prototype.remove = function (key) {
        var internalKey = getInternalKey(key);
        delete this.parameters[internalKey];
        this.informSubscribers(internalKey, undefined);
    };
    
    ParameterCollection.prototype.getAll = function () {
        return this.copyInto({});
    };

    ParameterCollection.prototype.copyInto = function (targetObject) {
        var self = this;
        _.each(_.keys(this.parameters), function (internalKey) {
            var originalKey = self.parameters[internalKey].key;
            var value = self.getValue(internalKey);
            targetObject[originalKey] = value;
        });

        if (this.parentCollection)
            return this.parentCollection.copyInto(targetObject);

        return targetObject;
    };

    ParameterCollection.prototype.createChildScope = function (initialValues) {
        return new ParameterCollection(initialValues, this);
    };

    ParameterCollection.prototype.subscribeForUpdates = function (parameterName, callback, ctxObject, optionallyTriggerForInitialValue) {
        if(!this.callbacks)
            this.callbacks = {}

        var internalKey = getInternalKey(parameterName);

        if(!this.callbacks[internalKey])
            this.callbacks[internalKey] = [];

        this.callbacks[internalKey].push({
            callback: callback,
            ctxObject: ctxObject
        });
        
        if(optionallyTriggerForInitialValue) {
            setTimeout(this.informSubscribers.bind(this, internalKey, this.getValue(parameterName)), 0);
        }
    };

    ParameterCollection.prototype.unsubscribeFromUpdates = function (parameterName, callback) {
        if(!this.callbacks)
            return;

        var internalKey = getInternalKey(parameterName);

        if(!this.callbacks[internalKey])
            return;

        this.callbacks[internalKey] = _.filter(this.callbacks[internalKey], function(subscription) {
            return subscription.callback !== callback;
        })

        if(this.callbacks[internalKey].length === 0)
            delete this.callbacks[internalKey];
    };

    ParameterCollection.prototype.informSubscribers = function (internalKey, newValue) {
        if(!this.callbacks)
            return;

        _.each(this.callbacks[internalKey], function (subscription) {
            subscription.callback(newValue, subscription.ctxObject);
        });
    };

    return ParameterCollection;
});
